import React from "react";
import moment from "moment";
import clsx from "clsx";
import { Grid, IconButton, Typography, makeStyles } from "@material-ui/core";
var useStyles = makeStyles(function (theme) {
  return {
    root: {
      margin: "1px 0"
    },
    button: {
      width: 36,
      height: 36,
      padding: 0
    },
    start: {
      borderTopLeftRadius: "50%",
      borderBottomLeftRadius: "50%"
    },
    end: {
      borderTopRightRadius: "50%",
      borderBottomRightRadius: "50%"
    },
    single: {
      borderRadius: "50%"
    },
    filled: {
      background: theme.palette.primary.main,
      "&:hover": {
        background: theme.palette.primary.dark
      }
    },
    range: {
      background: theme.palette.primary.light
    },
    buttonText: {},
    contrast: {
      color: theme.palette.primary.contrastText
    },
    today: {
      border: "1px solid rgba(0, 0, 0, 0.6)"
    }
  };
});
var today = moment().endOf("day");

var Day = function Day(_a) {
  var day = _a.day,
      rangeValid = _a.rangeValid,
      startDate = _a.startDate,
      endDate = _a.endDate,
      _onClick = _a.onClick,
      future = _a.future;
  var classes = useStyles();
  if (!day) return React.createElement(Grid, {
    item: true,
    className: classes.root
  }, React.createElement(Grid, {
    className: classes.button
  }));
  var outerStart = startDate && (day.day() === 0 || day.isSame(startDate, "d") || day.date() === 1);
  var outerEnd = startDate && (day.day() === 6 || day.clone().add(1, "days").date() === 1 || endDate && day.isSame(endDate, "d") || !endDate && day.isSame(startDate, "d"));
  var inRange = startDate && (endDate && day.isBetween(startDate, endDate, "day", "[]") || !endDate && day.isSame(startDate, "d"));
  var isEnd = day.isSame(startDate, "d") || day.isSame(endDate, "d");
  var isToday = day.isSame(moment(), "d");

  var inRangeValid = function inRangeValid() {
    var flag = false;

    if (rangeValid) {
      if (rangeValid[0] && rangeValid[1]) {
        flag = !day.isBetween(rangeValid[0], rangeValid[1], "day", "[]");
      } else if (rangeValid[0]) {
        flag = !day.isSameOrAfter(rangeValid[0]);
      } else if (rangeValid[1]) {
        flag = !day.isSameOrBefore(rangeValid[1]);
      }
    }

    return flag;
  };

  return React.createElement(Grid, {
    item: true,
    className: clsx(classes.root, outerStart && classes.start, outerEnd && classes.end, inRange && classes.range)
  }, React.createElement(IconButton, {
    onClick: function onClick() {
      return _onClick(day);
    },
    disabled: !future && day.isAfter(today) || inRangeValid(),
    className: clsx(classes.button, isEnd && classes.filled, isToday && classes.today)
  }, React.createElement(Typography, {
    variant: "body2",
    color: !future && day.isAfter(today) || inRangeValid() ? "inherit" : "textPrimary",
    className: clsx(classes.buttonText, isEnd && classes.contrast)
  }, day.format("D"))));
};

export default Day;